var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Hero',{attrs:{"title":_vm.$t('HERO_MESSAGE_MARKETING')},scopedSlots:_vm._u([{key:"description",fn:function(){return [_c('p',{staticClass:"capitalized-h3"},[_vm._v(" "+_vm._s(_vm.$t('HERO_CAROUSEL_HEADER_MARKETING'))+" ")])]},proxy:true}])}),_c('MarketingView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }